import { Component, EventEmitter, Output } from '@angular/core';
import { DateHelper } from '../../../../shared/helpers/date.helper';

@Component({
  standalone: false,
  selector: 'app-employee-overtime-report-modal',
  templateUrl: './employee-overtime-report-modal.component.html',
  styleUrls: ['../modal.component.scss']
})

export class EmployeeOvertimeReportModalComponent {
  @Output() readonly responseChanged = new EventEmitter();
  selectedMonth: Date;

  constructor(private dateHelper: DateHelper) {
  }

  onSelectMonth(event: Date, calendarRef: any): void {
    this.selectedMonth = event;
    event.setHours(12, 0, 0, 0); // fixed time to avoid the problem with time zones
    calendarRef.overlayVisible = false; // close the calendar
  }

  emitTrue(): void {
    const fromDate = this.selectedMonth;
    const toDate = this.dateHelper.getLastDayInMonth(fromDate.getMonth() + 1, fromDate.getFullYear());
    this.responseChanged.emit({ fromDate: fromDate, toDate: toDate });
  }

  emitFalse(): void {
    this.responseChanged.emit(null);
  }
}